const isWaitlist = (incentive) => incentive?.status === 'waitlist';

export default isWaitlist;